const vinNumberValidator = (value) => {
  let valid = true;
  let message = "";

  const invalidLettersRegex = /^\b(?:\i|o|q)+\b$/; //eslint-disable-line

  if (value.length < 17) {
    valid = false;
    message = "The VIN you have entered is not 17 characters long!";
  } else if (invalidLettersRegex.test(value)) {
    valid = false;
    message = "The VIN cannot contain the letters I, O or Q!";
  }

  return {
    valid,
    message,
  };
};

const emailValidator = (value) => {
  let valid = true;
  let message = "";

  if (!value.includes("@")) {
    valid = false;
    message = "Invalid email, must contain the character @";
  } else {
    var mailformat =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    valid = value.match(mailformat) !== null;
    if (!valid) message = "Invalid email address!";
  }

  return message;
};

// const dateValidator = (value) => {
//   let valid = true;
//   let message = "";

//   var regEx = /^\d{4}-\d{2}-\d{2}$/;
//   if (!value.match(regEx)) {
//     valid = false;
//     message = "Invalid date format, please check your input!";
//   } else {
//     var d = new Date(value);
//     var dNum = d.getTime();
//     if (!dNum && dNum !== 0) {
//       valid = false;
//       message = "Invalid date format, please check your input!";
//     } else {
//       // return d.toISOString().slice(0, 10) === value;
//     }
//   }

//   return { valid, message };
// };

const numberValidator = (value) => {
  let valid = true;
  let message = "";

  const regex = /^\d+$/;
  if (!regex.test(value)) {
    valid = false;
    message = "Invalid number!";
  }

  return { valid, message };
};

const specialCharactersValidator = (value) => {
  let valid = true;
  let message = "";

  const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/; //eslint-disable-line
  valid = regex.test(value);
  if (valid)
    message = "Invalid input, value cannot contain special characters!";

  return { valid, message };
};

const verifyTokenValidator = (value) => {
  let valid = true;
  let message = "";

  const regex = /^\d{6}$/g;

  valid = regex.test(value);
  if (!valid) message = "Tokens need to be 6 digits long.";

  return message;
};

const dateTimeValidator = (value) => {
  let valid = true;
  let message = "";

  const ISOregex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/; // eg. 2021-11-04T22:32

  valid = ISOregex.test(value);
  if (!valid) message = "Date format is incorrect.";
  return message;
};

const dateValidator = (value) => {
  let valid = true;
  let message = "";

  const ISOregex = /^\d{4}-\d{2}-\d{2}$/; // eg. 2021-11-04

  valid = ISOregex.test(value);
  if (!valid) message = "Date format is incorrect.";
  return message;
};

const inputValidators = {
  vin: vinNumberValidator,
  email: emailValidator,
  dateTime: dateTimeValidator,
  date: dateValidator,
  number: numberValidator,
  specialCharacter: specialCharactersValidator,
  token: verifyTokenValidator,
};

export default inputValidators;
